// extracted by mini-css-extract-plugin
export default {"button":"AddButton_button__yV5hb","text":"AddButton_text__snLUm","icon":"AddButton_icon__PbwLZ"};